import ActionType from './ActionType';
import Map from 'ol/Map';

export const initialMapState: MapState = {
  center: [0, 0],
  zoom: 3,
  olMap: null,
};

export interface MapState {
  center: [number, number];
  zoom: number;
  olMap: Map;
}

export interface MapAction {
  type: ActionType.SET_MAP;
  data: Map;
}

export const mapReducer = (state: MapState, action: MapAction) => {
  switch (action.type) {
    case ActionType.SET_MAP:
      // console.log('setting map in mapReducer: ', action.data);
      return { ...state, olMap: action.data };

    default:
      return state;
  }
};
